module.exports = __webpack_public_path__ + "static/media/01.990ecd6a.jpg";